import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../../../services/rest/rest.service';
import { UtilityService } from '../../../../utils/utility.service';
import { Agreement } from './agreement.domain';
import { AgreementStatus, AgreementType } from './agreement-type.enum';

@Injectable({
  providedIn: 'root'
})
export class AgreementsService {
  pendingAgreementsCount: number = 0;
  agreements: Array<Agreement>;
  readonly onAgreementsChange: Subject<number>;

  constructor(private restService: RestService) {
    this.onAgreementsChange = new Subject<number>();
  }

  fetchAgreements(): Observable<Array<Agreement>> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    if (this.agreements !== undefined) {
      return of(this.getCachedAgreements());
    } else {
      return this.restService
        .getResource('agreements.agreements')
        .get<Array<Agreement>>()
        .pipe(
          map((response: Array<Agreement>): Array<Agreement> => {
            self.pendingAgreementsCount = response.reduce((initialValue: number, agreement: Agreement): number => {
              const isAgreementUnsigned = agreement.agreementStatus === AgreementStatus.UNSIGNED;
              return (isAgreementUnsigned) ? initialValue + 1 : initialValue;
            }, 0);
            this.agreements = response;
            return this.getCachedAgreements();
          })
        );
    }
  }

  acceptTdAgreement(): Observable<Array<Agreement>> {
    const agreementData: Agreement = {
      agreementType: AgreementType.TDW_TERMS_AND_CONDITIONS,
      agreementStatus: AgreementStatus.ACCEPTED,
      exchangeSubscriptionData: {}
    };
    return this.updateAgreement(agreementData);
  }

  updateAgreement(agreementData: Agreement): Observable<Array<Agreement>> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    return this.restService
      .getResource('agreements.update')
      .put<Agreement, Array<Agreement>>(agreementData)
      .pipe(
        map((result: Array<Agreement>): Array<Agreement> => {
          this.agreements = result;
          this.onAgreementsChange.next(--self.pendingAgreementsCount);
          return this.getCachedAgreements();
        })
      );
  }

  removeTdAgreement(agreements: Array<Agreement>): Array<Agreement> {
    return agreements.filter((item: Agreement): boolean => item.agreementType !== AgreementType.TDW_TERMS_AND_CONDITIONS
        && item.agreementType !== AgreementType.TDW_TERMS_AND_CONDITIONS_LITE);
  }

  syncCachedAgreements(agreements: Array<Agreement>): void {
    this.agreements.forEach((item: Agreement): void => {
      if (agreements.some((agreement: Agreement): boolean => agreement.agreementType === item.agreementType)) {
        item.agreementStatus = AgreementStatus.ACCEPTED;
      }
    });
  }

  private getCachedAgreements(): Array<Agreement> {
    return UtilityService.deepClone(this.agreements);
  }
}

